import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function CustomLabelsSection() {
  const useCases = ['Weddings & Anniversaries', 'Corporate Events & Gifting', 'Restaurants & Hospitality', 'Music Festivals', 'College Parties', 'Personal Collections'];
  const galleryImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/mbvGpJ4WXXyta7tztM1svG/Caprices_Festival_example.jpg',
    caption: 'Caprices Festival 2024',
    description: 'Custom labels created for the prestigious Caprices Music Festival in Gstaad, Switzerland.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6Vof2mCQcqoBZL4nCTFAwW/EliaKuhnPhotographe2021AnniversaireLolapartie1BD-200.jpg',
    caption: 'Personal Birthday Party',
    description: 'Personalized bottles featuring a custom photo label for an intimate birthday celebration.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/bUtnCwR2sPz7j1YUKwqjaR/graduation_party_example.jpg',
    caption: 'Graduation Party',
    description: 'A graduation celebration featuring custom-labeled bottles from Chateau de Chaintres in the Loire Valley.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/wztTZfnX9tGvA384tbLFbU/fraternity_label_example.jpg',
    caption: 'The Gentlemen of Pine',
    description: 'Bespoke fraternity wine with a custom label from Chateau de Chaintres for a college organization.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/crkmGwoGx1uoFqZdXmjkz2/3448c6e8-6125-4d30-b636-e8c6b32b3f34.jpg',
    caption: 'Corporate Events',
    description: 'Custom-labeled bottles for a luxury French shoe brand corporate event and an internationally recognized nonprofit Art Center.'
  }];
  return <section id="custom-labels" className="py-24 bg-white overflow-hidden" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        {/* Content Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center mb-16" data-id="element-71">
          <span className="text-wine font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-72">
            Bespoke Design
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl text-charcoal font-bold mb-6 leading-tight" data-id="element-73">
            Your Label,{' '}
            <span className="italic text-wine font-normal" data-id="element-74">Your Story</span>
          </h2>

          <p className="text-brown/80 text-lg leading-relaxed mb-8" data-id="element-75">
            A great wine deserves a presentation that matches its quality. Our
            custom label service allows you to transform exceptional wines into
            personalized keepsakes. All done in partnership with{' '}
            <strong className="text-wine font-medium" data-id="element-76">
              Chateau de Chaintres
            </strong>{' '}
            vignobles, Loire Valley.
          </p>

          <div className="mb-10" data-id="element-77">
            <div className="flex flex-wrap justify-center gap-3" data-id="element-78">
              {useCases.map((useCase, index) => <span key={index} className="px-4 py-2 bg-cream-100 text-brown text-sm rounded-full border border-cream-200" data-id="element-79">
                  {useCase}
                </span>)}
            </div>
          </div>

          <div data-id="element-80">
            <a href="/design" className="inline-flex items-center justify-center px-8 py-4 bg-charcoal text-white rounded-sm font-medium hover:bg-brown transition-colors duration-300" data-id="element-81">
              Start Designing
            </a>
          </div>
        </motion.div>

        {/* Full-Width Gallery */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        staggerChildren: 0.1
      }} className="grid grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-82">
          {galleryImages.map((img, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1
        }} className="group" data-id="element-83">
              <div className="relative rounded-sm overflow-hidden shadow-subtle aspect-[3/4]" data-id="element-84">
                <img src={img.src} alt={img.caption} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-85" />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-charcoal/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-86"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-500" data-id="element-87">
                  <p className="text-white text-sm font-bold leading-tight mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-88">
                    {img.caption}
                  </p>
                  <p className="text-white/70 text-xs leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-75" data-id="element-89">
                    {img.description}
                  </p>
                </div>
              </div>
              <div className="mt-3" data-id="element-90">
                <p className="text-charcoal text-sm font-semibold" data-id="element-91">
                  {img.caption}
                </p>
                <p className="text-brown/50 text-xs leading-relaxed mt-1" data-id="element-92">
                  {img.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}